var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"urgent-tag"},[_c('span',{class:[_vm.status==3?'danger':_vm.status==2?'important':'commonly'],staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.status==3?'紧急':_vm.status==2?'重要':'一般'))])])}
var staticRenderFns = []

export { render, staticRenderFns }